export default "__VITE_ASSET__09cb318b__"